import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdColorTitle, IdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ISavedChartPanel, SavedChartPanel } from "../chart/savedChartPanel";

export interface ITaskPageData {
    canCreateTasks: boolean;
    canEditLimitedModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    units: IIdTitleNode[];
    states: IIdColorTitle[];
    priorities: IIdTitle[];
    taskTypes: ITaskEditTypeItem[];
    handlers: ICodeTitle[];
    personsInCharge: ICodeTitle[];
    chartPanels: ISavedChartPanel[];
}

export class TaskPageData implements ITaskPageData {
    canCreateTasks: boolean;
    canEditLimitedModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    units: IdTitleNode[];
    states: IdColorTitle[];
    priorities: IdTitle[];
    taskTypes: TaskEditTypeItem[];
    handlers: CodeTitle[];
    personsInCharge: CodeTitle[];
    chartPanels: SavedChartPanel[];

    constructor();
    constructor(obj: ITaskPageData);
    constructor(obj?: any) {
        this.canCreateTasks = obj && obj.canCreateTasks || false;
        this.canEditLimitedModuleProperties = obj && obj.canEditLimitedModuleProperties || false;
        this.canEditAllModuleProperties = obj && obj.canEditAllModuleProperties || false;
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.states = Base.getTypedArray(obj?.states, IdColorTitle);
        this.priorities = Base.getTypedArray(obj?.priorities, IdTitle);
        this.taskTypes = Base.getTypedArray(obj?.taskTypes, TaskEditTypeItem);
        this.handlers = Base.getTypedArray(obj?.handlers, CodeTitle);
        this.personsInCharge = Base.getTypedArray(obj?.personsInCharge, CodeTitle);
        this.chartPanels = Base.getTypedArray(obj ? obj.chartPanels : null, SavedChartPanel);
    }
}
